import { logger } from './logger';

export const withLogger =
  <Params extends Array<unknown> = Array<unknown>, ResponseType = unknown>(
    fn: (...params: Params) => Promise<ResponseType>,
  ) =>
  (...params: Params): Promise<ResponseType> =>
    fn(...params).catch((error) => {
      logger.log(error);
      throw error;
    });
